<template>
    <div class="box-shadow box-shadow--big">
        <div class="helper__wrapper">
            <div class="flex-row flex-start">
                <label class="fake-label row3">
                    <input
                        class="custom-input"
                        type="radio"
                        value="TORBIEL"
                        @change="updateType(false)"
                        name="left-breast-changes"
                        v-model="s3q8_2_typeVal"
                    />
                    <span class="input-container">{{ $t('CYSTS') }}</span>
                    <span class="checkmark"></span>
                </label>

                <label class="fake-label row3">
                    <input
                        class="custom-input"
                        type="radio"
                        value="WLOKNIAK"
                        @change="updateType(false)"
                        name="left-breast-changes"
                        v-model="s3q8_2_typeVal"
                    />
                    <span class="input-container small" style="padding-left: 45px">{{ $t('FIBROMA') }}</span>
                    <span class="checkmark"></span>
                </label>

                <label class="fake-label row3">
                    <input
                        class="custom-input"
                        type="radio"
                        value="BRODAWCZAK"
                        @change="updateType(false)"
                        name="left-breast-changes"
                        v-model="s3q8_2_typeVal"
                    />
                    <span class="input-container">{{ $t('PAPILLOMA') }}</span>
                    <span class="checkmark"></span>
                </label>

                <label class="fake-label row3">
                    <input
                        class="custom-input"
                        type="radio"
                        value="MASTOPATYCZNA"
                        @change="updateType(false)"
                        name="left-breast-changes"
                        v-model="s3q8_2_typeVal"
                    />
                    <span class="input-container">{{ $t('MASTHOPATIC_CHANGES') }}</span>
                    <span class="checkmark"></span>
                </label>

                <div class="flex-column">
                    <label class="fake-label row3">
                        <input
                            class="custom-input"
                            type="radio"
                            value="INNA"
                            @change="updateType(true)"
                            name="left-breast-changes"
                            v-model="s3q8_2_typeVal"
                        />
                        <span class="input-container">{{ $t('OTHER_WHAT') }}</span>
                        <span class="checkmark"></span>
                    </label>

                    <input
                        v-if="showValueInput"
                        :placeholder="$t('INSERT_CHANGE')"
                        type="text"
                        style="margin-top: -12px"
                        class="el-input__inner el-input__inner--small row3"
                        v-model="s3q8_2_typeDescription"
                        @change="updateDescription"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.s3q8_2_typeVal = this.$store.getters.survey.section3.q8_2_type;
        this.s3q8_2_typeDescription = this.$store.getters.survey.section3.q8_2_type;
        if (
            this.s3q8_2_typeVal != 'TORBIEL' &&
            this.s3q8_2_typeVal != 'WLOKNIAK' &&
            this.s3q8_2_typeVal != 'BRODAWCZAK' &&
            this.s3q8_2_typeVal != 'MASTOPATYCZNA' &&
            this.s3q8_2_typeVal
        ) {
            this.s3q8_2_typeVal = 'INNA';
            this.showValueInput = true;
        }
    },
    data() {
        return {
            s3q8_2_typeVal: this.q8_2_type,
            s3q8_2_typeDescription: this.q8_2_description,
            showValueInput: false,
        };
    },
    computed: {
        q8_2_type() {
            return this.$store.getters.survey.section3.q8_2_type;
        },
        q8_2_description() {
            return this.$store.getters.survey.section3.q8_2_type;
        },
    },
    methods: {
        updateType(showValueInput) {
            this.showValueInput = showValueInput;
            if (showValueInput == false) {
                this.$store.commit('STATE_SURVEY', {
                    section3: {
                        ...this.$store.getters.survey.section3,
                        q8_2_type: this.s3q8_2_typeVal,
                    },
                });
            }
            this.$emit('clicked');
        },
        updateDescription() {
            this.$store.commit('STATE_SURVEY', {
                section3: {
                    ...this.$store.getters.survey.section3,
                    q8_2_type: this.s3q8_2_typeDescription,
                },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// left-breast-changes-diagnostic.vue?7e5a9d2b